module.exports = __webpack_public_path__ + "img/welcome.9148864f.png";